/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:56:24
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 14:12:09
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { API, API_URL } from '@/config';
import { togglePendingStoreActions } from '@/utils/decorators';

import {
  FILL_BRAND_THEME,
} from './mutation-types';

export default {
  @togglePendingStoreActions()
  async getBrandTheme({ commit }) {
    const { theme, logos, is_error, brand_id } = (await API.get(`${API_URL}/theme`)).data.data;
    commit(FILL_BRAND_THEME, { theme, logos, is_error, brand_id });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Brand/actions.js